// @module BTM.PersonalizationAttributeSorting.PersonalizationAttributeSorting
define('BTM.PersonalizationAttributeSorting.PersonalizationAttributeSorting.View'
,	[
		'btm_personalizationattributesorting_personalizationattributesorting.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		btm_personalizationattributesorting_personalizationattributesorting_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class BTM.PersonalizationAttributeSorting.PersonalizationAttributeSorting.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_personalizationattributesorting_personalizationattributesorting_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service 
				(you'll need to deploy and activate the extension first)
			*/
			this.message = '';
			// var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/PersonalizationAttributeSorting.Service.ss'));

			// jQuery.get(service_url)
			// .then((result) => {

			// 	this.message = result;
			// 	this.render();
			// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return BTM.PersonalizationAttributeSorting.PersonalizationAttributeSorting.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.PersonalizationAttributeSorting.PersonalizationAttributeSorting.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
